// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"e509ae0c","61":"8bae05ee","379":"8bae05ee","483":"8bae05ee","530":"8bae05ee","597":"8bae05ee","790":"8bae05ee"}[chunkId] + ".chunk.css";
};